import { useEffect } from "react";

const SITE = "https://expansionrubi.com";
const DEFAULT_IMAGE = `${SITE}/expansion-rubi-logo.png`;

function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content);
}

export default function useSeo({ title, description, path = "", noindex = false, image }) {
  useEffect(() => {
    const fullTitle = title ? `${title} | Expansión Rubí` : "Expansión Rubí · Participa en la expansión de Rubí Perfumería";
    document.title = fullTitle;
    setMeta("name", "description", description);
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:url", `${SITE}${path}`);
    setMeta("property", "og:image", image || DEFAULT_IMAGE);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", description);
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) { link = document.createElement("link"); link.setAttribute("rel", "canonical"); document.head.appendChild(link); }
    link.setAttribute("href", `${SITE}${path}`);
  }, [title, description, path, noindex, image]);
}
